import React from 'react';
import './ContactoEliminacion.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const ContactoEliminacion = () => {
    return (
        <>
            <Header minimal={true} searchBar={true} backOn={true} />
            <div className="contact-delete-container">
                <h1 className="contact-delete-title">Solicitud de Eliminación de Cuenta</h1>

                <section className="contact-delete-section contact-delete-intro-section">
                    <p className="contact-delete-intro-text">
                        En Minymol respetamos tu derecho a la privacidad y a controlar tus datos personales.
                        Si deseas eliminar permanentemente tu cuenta y toda la información asociada,
                        sigue el proceso que se detalla a continuación.
                    </p>
                </section>

                <section className="contact-delete-section contact-delete-steps-section">
                    <h2>¿Cómo solicitar la eliminación de tu cuenta?</h2>

                    <div className="contact-delete-step-card">
                        <div className="contact-delete-step-number">1</div>
                        <div className="contact-delete-step-content">
                            <h3>Envía un correo electrónico</h3>
                            <p>Dirígete a tu cliente de correo y envía un email a:</p>
                            <div className="contact-delete-email-box">
                                <strong>notificaciones@minymol.com</strong>
                            </div>
                        </div>
                    </div>

                    <div className="contact-delete-step-card">
                        <div className="contact-delete-step-number">2</div>
                        <div className="contact-delete-step-content">
                            <h3>Escribe el asunto correcto</h3>
                            <p>En el campo de asunto del correo, escribe exactamente:</p>
                            <div className="contact-delete-subject-box">
                                <strong>Eliminación cuenta</strong>
                            </div>
                        </div>
                    </div>

                    <div className="contact-delete-step-card">
                        <div className="contact-delete-step-number">3</div>
                        <div className="contact-delete-step-content">
                            <h3>Completa el cuerpo del mensaje</h3>
                            <p>En el cuerpo del correo, incluye la siguiente información:</p>
                            <ul className="contact-delete-info-list">
                                <li><strong>Número de celular:</strong> El número registrado en tu cuenta (campo obligatorio)</li>
                                <li><strong>Motivo de la eliminación:</strong> Explica brevemente por qué deseas eliminar tu cuenta</li>
                            </ul>
                            <div className="contact-delete-example-box">
                                <p className="contact-delete-example-title">📝 Ejemplo de correo:</p>
                                <div className="contact-delete-example-content">
                                    <p><strong>Asunto:</strong> Eliminación cuenta</p>
                                    <p><strong>Cuerpo:</strong></p>
                                    <p>Número de celular: +57 300 123 4567</p>
                                    <p>Motivo: Ya no utilizo la aplicación y deseo que mis datos sean eliminados por completo.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="contact-delete-section contact-delete-warning-section">
                    <div className="contact-delete-warning-box">
                        <h3>⚠️ Información importante</h3>
                        <ul>
                            <li>
                                <strong>Eliminación permanente:</strong> Una vez procesada tu solicitud,
                                toda tu información será eliminada de manera definitiva e irreversible.
                            </li>
                            <li>
                                <strong>Datos eliminados:</strong> Se borrarán todos tus datos personales incluyendo:
                                nombre, número de celular, correo electrónico, dirección, historial de pedidos,
                                productos, conversaciones y cualquier otra información asociada a tu cuenta.
                            </li>
                            <li>
                                <strong>Identificación única:</strong> Tu número de celular es único en nuestra base
                                de datos y es suficiente para identificar y eliminar completamente tu cuenta.
                            </li>
                            <li>
                                <strong>Sin retención de datos:</strong> No conservamos ninguna información después
                                de la eliminación. Este proceso es irreversible.
                            </li>
                            <li>
                                <strong>Tiempo de procesamiento:</strong> Procesaremos tu solicitud en un plazo
                                máximo de 48 horas hábiles.
                            </li>
                        </ul>
                    </div>
                </section>

                <section className="contact-delete-section contact-delete-help-section">
                    <h2>¿Necesitas ayuda?</h2>
                    <p>
                        Si tienes alguna duda sobre el proceso de eliminación de cuenta o necesitas asistencia,
                        puedes contactarnos al mismo correo: <strong>notificaciones@minymol.com</strong>
                    </p>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default ContactoEliminacion;
